import React, { useCallback, useEffect, useState } from 'react';
import { Pagination, Modal, Button } from '@roo/roo';
import { TableNew, Input } from 'RooV1.12';
import request from '@/utils/request';
import DistributeList from '../distributeList';
import { ALIGN_TYPES } from '../../types';
import dayJs from 'dayjs';
import './index.scss';

const UnallocatedTable: React.FC = () => {
    // 分页
    const [pageNum, setPageNum] = useState(1);
    const [pageSize, setPageSize] = useState(10);
    const [total, setTotal] = useState(0);
    // 待分配列表数据
    const [unallocatedList, setUnallocatedList] = useState<urls.distribute.StoreDetail[]>([]);
    const [bindWmPoiId, setBindWmPoiId] = useState(0);
    // Modal展示
    const [operateVisible, setOperateVisible] = useState(false);
    // 搜索值
    const [searchValue, setSearchValue] = useState('');

    // 分配门店列表
    const columns = [
        {
            title: <span className="list-header">门店名称</span>,
            dataIndex: 'wmPoiName',
            width: 70,
            align: ALIGN_TYPES.LEFT,
            render(wmPoiName: any) {
                return <span className="list-content">{wmPoiName}</span>;
            },
        },
        {
            title: <span className="list-header">门店ID</span>,
            dataIndex: 'wmPoiId',
            width: 70,
            align: ALIGN_TYPES.LEFT,
            render(wmPoiId: any) {
                return <span className="list-content">{wmPoiId}</span>;
            },
        },
        {
            title: <span className="list-header">签约时间</span>,
            dataIndex: 'signTime',
            width: 70,
            align: ALIGN_TYPES.LEFT,
            render(signTime: any) {
                return (
                    <span className="list-content">
                        {dayJs(signTime * 1000).format('YYYY-MM-DD')}
                    </span>
                );
            },
        },
        {
            title: <span className="list-header">运营人</span>,
            width: 30,
            dataIndex: 'operations',
            align: ALIGN_TYPES.CENTER,
            render(operations: any, record: any) {
                return (
                    <span
                        className="list-cotent-operate"
                        onClick={() => {
                            setOperateVisible(true);
                            setBindWmPoiId(record.wmPoiId);
                        }}
                    >
                        分配
                    </span>
                );
            },
        },
    ];

    // 获取未分配门店列表数据
    const getUnallocatedList = (searchVal?: string) => {
        const parms = {
            pageNum,
            pageSize,
            wmPoiId: searchVal !== null ? searchVal : '',
        };
        request
            .get('/api/thirdpartnar/poi/distribution/pending/list', parms)
            .then((res: urls.serverBase<urls.distribute.UnallocatedList>) => {
                if (res.data) {
                    const { list, total } = res.data;
                    setTotal(total);
                    setUnallocatedList(list);
                }
            })
            .catch(error => {
                console.error(error);
            });
    };

    useEffect(() => {
        getUnallocatedList();
    }, [pageNum, pageSize]);

    // 门店分配子组件回调
    const handleBind = useCallback(status => {
        if (status) {
            setOperateVisible(false);
            getUnallocatedList();
        }
    }, []);

    return (
        <div className="unalocated-store">
            <div className="unalocated-header">
                <span className="header-title">待分配门店</span>
                <span>
                    <Input
                        className="input-search"
                        size="normal"
                        styleType="plaintext"
                        placeholder="请输入门店ID"
                        onPressEnter={() => {
                            getUnallocatedList(searchValue);
                        }}
                        onChange={e => {
                            setSearchValue(e.target.value);
                        }}
                    />
                    <Button
                        className="search-confirm"
                        onClick={() => {
                            getUnallocatedList(searchValue);
                        }}
                    >
                        搜索
                    </Button>
                </span>
            </div>
            <TableNew rowKey="id" columns={columns} data={unallocatedList} bordered />
            <div className="pagination-right">
                <Pagination
                    total={total}
                    currentPage={pageNum}
                    pageSize={pageSize}
                    onChange={pageNum => setPageNum(pageNum)}
                />
            </div>
            <Modal
                title={'绑定运营人'}
                visible={operateVisible}
                onCancel={() => {
                    setOperateVisible(false);
                }}
                showCancelButton={false}
                showConfirmButton={false}
                size="lg"
            >
                {operateVisible && (
                    <DistributeList
                        type="distribute"
                        handleBind={handleBind}
                        wmPoiId={bindWmPoiId}
                    />
                )}
            </Modal>
        </div>
    );
};

export default UnallocatedTable;
